"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3537],{

/***/ 66806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ EnhancedLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);






var EnhancedLink = function(_param) {
    var href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "children"
    ]);
    var isExternal = href.startsWith("http");
    var InnerLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        as: "a",
        target: isExternal ? "_blank" : undefined,
        href: isExternal ? href : undefined
    }, props), {
        children: children
    }));
    return isExternal ? InnerLink : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: InnerLink
    });
};


/***/ }),

/***/ 31046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ HTMLText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var _EnhancedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66806);








var parserOptions = {
    replace: function(domNode) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(domNode, html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .Element */ .W_)) {
            if (domNode.name === "a") {
                var attribs = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .attributesToProps */ .e_)(domNode.attribs);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EnhancedLink__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedLink */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    href: attribs.href
                }, attribs), {
                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(domNode.children, parserOptions)
                }));
            }
        }
    }
};
var HTMLText = function(_param) {
    var text = _param.text, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    var parsedHtml = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text, parserOptions);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        __css: {
            p: {
                mb: 4
            },
            "ol, ul": {
                ml: 5
            },
            a: {
                textDecoration: "underline"
            }
        }
    }, props), {
        children: parsedHtml
    }));
};


/***/ }),

/***/ 21097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23887);





var Image = function(_param) {
    var imageStyle = _param.imageStyle, image = _param.image, hideCopyright = _param.hideCopyright, wrapperProps = _param.wrapperProps, description = _param.description, copyrightInside = _param.copyrightInside, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "imageStyle",
        "image",
        "hideCopyright",
        "wrapperProps",
        "description",
        "copyrightInside"
    ]);
    if (!imageStyle) return null;
    var showCopyright = !hideCopyright && image.copyright;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "image-".concat(image.id),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                pos: "relative"
            }, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .Ei, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        htmlWidth: imageStyle.width,
                        htmlHeight: imageStyle.height,
                        src: imageStyle.url,
                        width: "100%",
                        loading: "lazy",
                        alt: image.alt || ""
                    }, props)),
                    showCopyright && copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        pos: "absolute",
                        left: 0,
                        bottom: 0,
                        bg: "rgba(0,0,0, .4)",
                        color: "white",
                        p: 1,
                        fontSize: "xxs",
                        children: [
                            "Foto \xa9 ",
                            image.copyright
                        ]
                    })
                ]
            })),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                pt: 1,
                fontSize: "md",
                children: description
            }),
            showCopyright && !copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                fontSize: "xxs",
                children: [
                    "Foto \xa9 ",
                    image.copyright
                ]
            })
        ]
    });
};


/***/ }),

/***/ 13537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TeaserList": function() { return /* binding */ TeaserList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52494);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_icons_all_files_io5_IoChevronForward__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18935);
/* harmony import */ var _Common_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21097);
/* harmony import */ var _Common_HTMLText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31046);






var TeaserList = function(param) {
    var title = param.title, url = param.url, image = param.image, text = param.text, layout = param.layout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Grid */ .rj, {
        templateColumns: "repeat(12, 1fr)",
        gap: {
            base: 0,
            md: 6
        },
        width: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .GridItem */ .P4, {
                colSpan: {
                    base: 12,
                    md: 4
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                    pos: "relative",
                    overflow: "hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
                                    borderTopRadius: "sm",
                                    imageStyle: image.imageStyle,
                                    image: image,
                                    hideCopyright: true
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .GridItem */ .P4, {
                colSpan: {
                    base: 12,
                    md: 8
                },
                display: "flex",
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                            mt: {
                                base: 2,
                                md: 0
                            },
                            display: "block",
                            as: "a",
                            fontSize: "2xl",
                            fontWeight: "bold",
                            mb: {
                                base: 0,
                                md: 2
                            },
                            color: "primary",
                            _hover: {
                                color: "primaryDark"
                            },
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_HTMLText__WEBPACK_IMPORTED_MODULE_3__/* .HTMLText */ .J, {
                        mt: 2,
                        color: "gray.600",
                        noOfLines: 4,
                        text: text
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        alignItems: "center",
                        justifyContent: "flex-start",
                        mt: "auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                                as: "a",
                                layerStyle: "link_button_blue",
                                mt: 4,
                                children: [
                                    "Mehr erfahren",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                        ml: 1,
                                        as: _react_icons_all_files_io5_IoChevronForward__WEBPACK_IMPORTED_MODULE_6__/* .IoChevronForward */ .m
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);